import "../../../css/Copyrights.css";﻿

﻿    export var imagerieCopyrights = [
        {
            "levelMax": "19",
            "copyright": "© Groupe Nippour",
            "bbox": {
                "minX": -7966374,
                "minY": 6138181,
                "maxX": -7870004,
                "maxY": 6201560
            },
            "levelMin": "12"
        },
        {
            "levelMax": "20",
            "copyright": "© MRC Beauharnois-Salaberry",
            "bbox": {
                "minX": -8261503,
                "minY": 5644304,
                "maxX": -8200545,
                "maxY": 5678304
            },
            "levelMin": "12"
        },
        {
            "levelMax": "21",
            "copyright": "© MRC Ville de Rimouski",
            "bbox": {
                "minX": -7661421,
                "minY": 6153555,
                "maxX": -7603567,
                "maxY": 6195427
            },
            "levelMin": "12"
        },
        {
            "levelMax": "21",
            "copyright": "© MRC Ville de Rimouski",
            "bbox": {
                "minX": -7670498,
                "minY": 6174917,
                "maxX": -7667323,
                "maxY": 6176823
            },
            "levelMin": "12"
        },
        {
            "levelMax": "21",
            "copyright": "© MRC Ville de Rimouski",
            "bbox": {
                "minX": -7669362,
                "minY": 6170914,
                "maxX": -7662636,
                "maxY": 6176803
            },
            "levelMin": "12"
        },
        {
            "levelMax": "21",
            "copyright": "© MRC Ville de Sainte-Anne-des-Monts",
            "bbox": {
                "minX": -7414965,
                "minY": 6292220,
                "maxX": -7380965,
                "maxY": 6305801
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Gouvernement du Québec & © municipalité Îles-de-la-Madeleine 2015",
            "bbox": {
                "minX": -6906134,
                "minY": 5975315,
                "maxX": -6832167,
                "maxY": 6047860
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Gouvernement du Québec & © municipalité Îles-de-la-Madeleine 2015",
            "bbox": {
                "minX": -6848714,
                "minY": 6069054,
                "maxX": -6835426,
                "maxY": 6075311
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© MRC de Portneuf",
            "bbox": {
                "minX": -7954660,
                "minY": 5969738,
                "maxX": -7738230,
                "maxY": 6139460
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© MRC de Portneuf",
            "bbox": {
                "minX": -7770144,
                "minY": 6066982,
                "maxX": -7769876,
                "maxY": 6067465
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© MRC Maria-Chapdelaine, MRC le Domaine-du-Roy, MRC de Lac-Saint-Jean-Est",
            "bbox": {
                "minX": -8120204,
                "minY": 6106704,
                "maxX": -7940124,
                "maxY": 6313485
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Communauté métropolitaine de Montréal, 2013",
            "bbox": {
                "minX": -8261699,
                "minY": 5657750,
                "maxX": -8133228,
                "maxY": 5778576
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Communauté métropolitaine de Montréal, 2007",
            "bbox": {
                "minX": -8193157,
                "minY": 5751760,
                "maxX": -8178703,
                "maxY": 5766551
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Projet régional orthophotographies des Laurentides, 2013",
            "bbox": {
                "minX": -8362016,
                "minY": 5698053,
                "maxX": -8213510,
                "maxY": 5854081
            },
            "levelMin": "12"
        },
        {
            "levelMax": "20",
            "copyright": "© Communauté métropolitaine de Québec",
            "bbox": {
                "minX": -7994283,
                "minY": 5872657,
                "maxX": -7861553,
                "maxY": 5997776
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Rouyn-Noranda 2015",
            "bbox": {
                "minX": -8853985,
                "minY": 6066582,
                "maxX": -8707507,
                "maxY": 6203083
            },
            "levelMin": "12"
        },
        {
            "levelMax": "20",
            "copyright": "© Projet régional de l’Estrie, 2013",
            "bbox": {
                "minX": -8027063,
                "minY": 5668861,
                "maxX": -7993036,
                "maxY": 5704389
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Projet régional de l’Estrie, 2013",
            "bbox": {
                "minX": -8068998,
                "minY": 5622122,
                "maxX": -7835096,
                "maxY": 5773177
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Centre-du-Québec 2015",
            "bbox": {
                "minX": -8125410,
                "minY": 5714634,
                "maxX": -7945444,
                "maxY": 5872323
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Projet régional de couverture orthophotographique de la Montérégie 2014",
            "bbox": {
                "minX": -8312202,
                "minY": 5620164,
                "maxX": -8050396,
                "maxY": 5798474
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Projet régional d'Antoine-Labelle 2014",
            "bbox": {
                "minX": -8360949,
                "minY": 5981296,
                "maxX": -8359424,
                "maxY": 5982820
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Projet régional d'Antoine-Labelle 2014",
            "bbox": {
                "minX": -8369165,
                "minY": 5975679,
                "maxX": -8367582,
                "maxY": 5977905
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Projet régional d'Antoine-Labelle 2014",
            "bbox": {
                "minX": -8439624,
                "minY": 5772795,
                "maxX": -8303759,
                "maxY": 5939847
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© Projet régional de l'Outaouais 2014",
            "bbox": {
                "minX": -8496639,
                "minY": 5680081,
                "maxX": -8387243,
                "maxY": 5755600
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "© MRC de Portneuf",
            "bbox": {
                "minX": -8078970,
                "minY": 5870398,
                "maxX": -7920210,
                "maxY": 6071924
            },
            "levelMin": "12"
        },
        {
            "levelMax": "8",
            "copyright": "© NASA Earth Observatory",
            "bbox": {
                "minX": -20025551,
                "minY": -19848960,
                "maxX": 20007240,
                "maxY": 20027725
            },
            "levelMin": "0"
        },
        {
            "levelMax": "19",
            "copyright": "© CNES",
            "bbox": {
                "minX": -9115959,
                "minY": 5512462,
                "maxX": -6112988,
                "maxY": 9040961
            },
            "levelMin": "9"
        },
        {
            "levelMax": "19",
            "copyright": "© CNES",
            "bbox": {
                "minX": -6963312,
                "minY": 5895949,
                "maxX": -6748076,
                "maxY": 6158118
            },
            "levelMin": "9"
        },
        {
            "levelMax": "11",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -6907088,
                "minY": 5972393,
                "maxX": -6830861,
                "maxY": 6078430
            },
            "levelMin": "9"
        },
        {
            "levelMax": "11",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7185141,
                "minY": 6282052,
                "maxX": -6862603,
                "maxY": 6441410
            },
            "levelMin": "9"
        },
        {
            "levelMax": "11",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8883030,
                "minY": 5620082,
                "maxX": -6337921,
                "maxY": 8998554
            },
            "levelMin": "9"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8449983,
                "minY": 5911793,
                "maxX": -8439505,
                "maxY": 5915382
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8436503,
                "minY": 5916782,
                "maxX": -8432826,
                "maxY": 5919175
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8468182,
                "minY": 5923504,
                "maxX": -8461096,
                "maxY": 5926446
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8474835,
                "minY": 5929114,
                "maxX": -8473431,
                "maxY": 5930456
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8331923,
                "minY": 5836496,
                "maxX": -8284380,
                "maxY": 5953174
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8468782,
                "minY": 5972935,
                "maxX": -8463491,
                "maxY": 5974584
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8462865,
                "minY": 5972958,
                "maxX": -8458773,
                "maxY": 5975030
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8458936,
                "minY": 5974809,
                "maxX": -8458776,
                "maxY": 5975182
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8430219,
                "minY": 5984404,
                "maxX": -8420968,
                "maxY": 5988835
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8447165,
                "minY": 5988170,
                "maxX": -8446094,
                "maxY": 5989254
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8442416,
                "minY": 5991938,
                "maxX": -8435246,
                "maxY": 5994284
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7920546,
                "minY": 5967638,
                "maxX": -7883955,
                "maxY": 6009213
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8397824,
                "minY": 6038356,
                "maxX": -8390279,
                "maxY": 6048712
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7856456,
                "minY": 6157676,
                "maxX": -7856442,
                "maxY": 6157687
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7859902,
                "minY": 6157585,
                "maxX": -7844847,
                "maxY": 6164919
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7850813,
                "minY": 6123556,
                "maxX": -7784454,
                "maxY": 6169482
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8637716,
                "minY": 6157635,
                "maxX": -8627245,
                "maxY": 6190434
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7825184,
                "minY": 6190435,
                "maxX": -7820186,
                "maxY": 6219426
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7951102,
                "minY": 6216113,
                "maxX": -7943935,
                "maxY": 6224728
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8053843,
                "minY": 6176903,
                "maxX": -7990659,
                "maxY": 6232119
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8766786,
                "minY": 6223939,
                "maxX": -8755628,
                "maxY": 6235136
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8351191,
                "minY": 6228026,
                "maxX": -8280211,
                "maxY": 6263866
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8313213,
                "minY": 5996003,
                "maxX": -8012404,
                "maxY": 6279583
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8212957,
                "minY": 6271185,
                "maxX": -8196572,
                "maxY": 6282094
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8702910,
                "minY": 6315048,
                "maxX": -8691727,
                "maxY": 6329955
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7922730,
                "minY": 6232649,
                "maxX": -7903682,
                "maxY": 6343242
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8727658,
                "minY": 6426141,
                "maxX": -8650415,
                "maxY": 6512687
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8070665,
                "minY": 6577187,
                "maxX": -8070660,
                "maxY": 6577191
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8281146,
                "minY": 6270908,
                "maxX": -8041593,
                "maxY": 6591424
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8572292,
                "minY": 6594486,
                "maxX": -8557755,
                "maxY": 6599302
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8098495,
                "minY": 6665633,
                "maxX": -8098491,
                "maxY": 6665637
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7585992,
                "minY": 6768392,
                "maxX": -7582085,
                "maxY": 6777651
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7582133,
                "minY": 6801118,
                "maxX": -7577765,
                "maxY": 6809735
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -7594382,
                "minY": 6459076,
                "maxX": -6337921,
                "maxY": 6983835
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8710806,
                "minY": 8058128,
                "maxX": -8698590,
                "maxY": 8067699
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8701095,
                "minY": 8071746,
                "maxX": -8699303,
                "maxY": 8071786
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8707832,
                "minY": 8071746,
                "maxX": -8706304,
                "maxY": 8071791
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8687258,
                "minY": 8071662,
                "maxX": -8687249,
                "maxY": 8071827
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8704621,
                "minY": 8071758,
                "maxX": -8704617,
                "maxY": 8071855
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8617132,
                "minY": 8400724,
                "maxX": -8615882,
                "maxY": 8401757
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8691236,
                "minY": 8574341,
                "maxX": -8688768,
                "maxY": 8574520
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8708968,
                "minY": 8572993,
                "maxX": -8696972,
                "maxY": 8576874
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8711019,
                "minY": 8577006,
                "maxX": -8707919,
                "maxY": 8585878
            },
            "levelMin": "12"
        },
        {
            "levelMax": "19",
            "copyright": "Includes material © (2010-2013) RapidEye AG, Germany, All rights reserved",
            "bbox": {
                "minX": -8883030,
                "minY": 6477381,
                "maxX": -7048680,
                "maxY": 8998554
            },
            "levelMin": "12"
        }
    ];
